import axios from 'axios'
import { API_URL } from './index'
import { REQUEST_SEARCH, RECEIVE_SEARCH, REFRESH_SEARCH } from '../constants/ActionTypes'

//= ===============================
// Fetch One Query Action
//= ===============================

const refreshSearch = (query, filter) => {
	return {
		type: REFRESH_SEARCH,
		query,
		filter
	}
}

const requestSearch = (query, filter) => {
	return {
		type: REQUEST_SEARCH,
		query,
		filter
	}
}

const receiveSearch = (query, filter, response) => {
	return {
		type: RECEIVE_SEARCH,
		query,
		filter,
		payload: response.data,
		receivedAt: Date.now()
	}
}

const fetchSearch = (query, filter, pageCount) => {
	return dispatch => {
		dispatch(requestSearch(query, filter))
		
		let data = {
			query1: query
		}
		
		let headers = {headers:{'Content-Type':'application/json'}}
	
		let url = `${API_URL}/story/query?page=` + pageCount + `&limit=5&type=` + filter
		axios.post(url, data, headers)
		.then((response) => {
			console.log(response)
			dispatch(receiveSearch(query, filter, response))
		})
		.catch((error) => {
			console.log(error)
		})
	}
}

const shouldSearch = (state, query) => {
	return true
}

export const loadSearch = (query, filter, nextPage, refresh) => (dispatch, getState) => {
	if (refresh === true) {
		dispatch(refreshSearch(query, filter))
		const pageCount = 0
		if (shouldSearch(getState(), query)) {
			return dispatch(fetchSearch(query, filter, pageCount))
		}
	}
	const {
		pageCount = 0
	} = getState().searchByFilter[filter] || {}
	if (pageCount > 0 && !nextPage) {
		return null
	}
	if (shouldSearch(getState(), query)) {
		return dispatch(fetchSearch(query, filter, pageCount))
	}
}


// WEBPACK FOOTER //
// ./src/actions/search.js